export const AGENT_TRUST_RECEIPT_PANEL_ID = 'agentTrustReceiptPanel';

export type AgentTrustReceiptActor = {
	id: string;
	name: string;
	type: 'agent' | 'person';
};

export type AgentTrustReceiptScenario = {
	id: string;
	label: string;
	description: string;
};

export type AgentTrustReceiptSignal = {
	id: string;
	label: string;
	value: string;
};

export type AgentTrustReceipt = {
	contentId: string;
	actor: AgentTrustReceiptActor;
	scenario: AgentTrustReceiptScenario;
	summary: string;
	signals: AgentTrustReceiptSignal[];
};
